export const config = {
	apiUrl: (import.meta.env.VITE_API_URL || "") + "/api",
	googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || "",
	// Web address people use for Jira / Confluence (links only — API calls go through api.atlassian.com)
	jiraBaseUrl: ((import.meta.env.VITE_JIRA_BASE_URL as string | undefined) || "https://prestosports.jira.com").replace(/\/+$/, "")
};

/** Link to a Jira issue, e.g. jiraIssueUrl("WS-123") */
export const jiraIssueUrl = (key: string) => `${config.jiraBaseUrl}/browse/${key}`;
